<template>
  <div>
    <article class="mini-card" v-if="view == `list`" v-loading="installing">
      <div
        class="mini-card-type"
        v-bind:class="{
          native: atom.type == 'native',
          web: atom.type == 'web',
        }"
      >
        <span>{{ atom.privacy }}</span>
      </div>
      <div class="mini-card-left-side">
        <router-link
          :to="{ name: 'SingleAtom', params: { id: atom.id } }"
        >
          <div class="mini-article-card-title">
            <h3>
              {{ atom.title.substring(0, 100)
              }}<i class="vik vik-verified-dc"
                ><span class="path1"></span><span class="path2"></span
              ></i>
            </h3>
          </div>
        </router-link>
      </div>

      <div class="mini-card-right-side">
        <div class="tags">
          <div v-if="parsedTags(atom.tags).length">
            <span v-for="tag in parsedTags(atom.tags)" :key="tag">{{
              tag
            }}</span>
          </div>
        </div>
        <div class="btn-group">
          <!-- Добавить определение из маректпелйса\ клонированый \ локальный -->
          <!-- 
          <span class="btn-icon atom-source">Local</span>
          <span class="btn-icon atom-source"><i class="vik vik-add-group"></i>Fork</span>
          -->
          <button class="btn btn-sm btn-icon" :disabled="!showInstallButton">
            <i
              class="vik"
              :class="[
                {
                  'vik-download-dc': showInstallButton,
                  'vik-check-dc': !showInstallButton,
                },
              ]"
              ><span class="path1"></span><span class="path2"></span
            ></i>
          </button>
        </div>
      </div>
    </article>

    <article class="mini-card" v-else v-loading="installing">
      <div
        class="mini-card-type"
        v-bind:class="{
          native: atom.type == 'native',
          web: atom.type == 'web',
        }"
      >
        <span>v{{ version }}</span>
      </div>
      <div class="mini-article-card-header">
        <div class="tags">
          <div v-if="parsedTags(atom.tags).length">
            <span v-for="tag in parsedTags(atom.tags)" :key="tag">{{
              tag
            }}</span>
          </div>
        </div>
        <div class="btn-group ml-auto">
          <!-- Добавить определение из маректпелйса\ клонированый \ локальный -->
          <!-- 
          <span class="atom-source">Local</span>
          <span class="atom-source"><i class="vik vik-add-group"></i>Fork</span>
          -->
          <button
            class="btn btn-sm btn-icon"
            :disabled="!showInstallButton"
            @click="install"
          >
            <i
              class="vik"
              :class="[
                {
                  'vik-download-dc': showInstallButton,
                  'vik-check-dc': !showInstallButton,
                },
              ]"
              ><span class="path1"></span><span class="path2"></span
            ></i>
          </button>
        </div>
      </div>

      <router-link :to="{ name: 'SingleAtom', params: { id: atom.id } }">
        <div class="mini-article-card-title">
          <h3>
            {{ atom.title.substring(0, 100)
            }}<!-- <i class="vik vik-verified-dc"
              ><span class="path1"></span><span class="path2"></span
            ></i>-->
          </h3>
          <p>{{ atom.description }}</p>
        </div>
      </router-link>
    </article>

    <!--
    <article class="mini-card">
      <div class="mini-article-card-header">
        <div class="tags">
          <div v-if="parsedTags(atom.tags).length">
            <span v-for="tag in parsedTags(atom.tags)" :key="tag">{{tag}}</span>
          </div>
          <span v-else>no tags</span>
        </div>
        <div class="btn-group ml-auto" v-if="!local">
          <button class="btn btn-sm btn-secondary">install</button>
        </div>
      </div>

      <div class="mini-article-card-title">
        <router-link :to="{ name: 'AtomView', params: { hash: atom.hash } }">
          <h3>{{ atom.title.substring(0,100) }}</h3>
        </router-link>
      </div>
      <div class="mini-article-meta">
        <div class="mini-article-author">
          <div class="author-avatar">
            <img class="rounded-circle" src="/assets/avatar/hackerman.png" alt />
          </div>
          <a href="#" class="author-name">hackerman</a>
        </div>
        <div class="atom-card-info-cont">
          <span class="atom-card-info">version: 1.00</span>
          <span class="atom-card-info">last update: 21.01.2020</span>
        </div>
      </div>
    </article>
    -->
    <!--
    <a-card>
      <p slot="title">
        <router-link
          :to="{ name: 'SingleAtom', params: { hash: atom.hash } }"
        >{{ atom.title.substring(0,25) }}</router-link>
      </p>
      <div v-if="!local" slot="extra">
        <a-button
          v-if="showInstallButton"
          size="small"
          :loading="installing"
          @click="install"
        >Install</a-button>
        <p v-else>Installed</p>
      </div>
      <p style="overflow: auto">{{atom.description}}</p>
      <div v-if="atom.tags">
        <a-tag v-for="tag in parsedTags(atom.tags)" :key="tag">{{tag}}</a-tag>
      </div>
    </a-card>
    -->
  </div>
</template>
<script>
import * as utils from "@/utils.js";
export default {
  props: ["local", "atom", "view"],
  data() {
    return {
      showInstallButton: false,
      installing: false,
    };
  },
  mounted() {
    this.checkInstall();
  },
  computed: {
    getType() {
      return this.atom["type"];
    },
    version(){
      return parseFloat(this.atom.revision)
    }
  },
  methods: {
    parsedTags(raw) {
      if (raw != null) {
        try {
          let p = JSON.parse(raw);
          return p;
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    async checkInstall() {
      let rawData = await utils.loadLocalAtomInfo(this.atom.id);
      console.log('checkInstall rawData', rawData)
      if (rawData && rawData.error && rawData.error === "record not found") {
        this.showInstallButton = true;
      } else {
        this.showInstallButton = false;
      }
    },
    async install() {
      let that = this;
      this.installing = true;
      console.log("hash:", this.atom.id);
      await utils.installAtom(this.atom.id);

      setTimeout(() => {
        that.installing = false;
        that.checkInstall();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/internal/AtomCard.vue